import { render, staticRenderFns } from "./ActivationEmailItem.vue?vue&type=template&id=5ea224c6&scoped=true&"
import script from "./ActivationEmailItem.vue?vue&type=script&lang=ts&"
export * from "./ActivationEmailItem.vue?vue&type=script&lang=ts&"
import style0 from "./ActivationEmailItem.vue?vue&type=style&index=0&id=5ea224c6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea224c6",
  null
  
)

export default component.exports